var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.002,
    height: 42.002,
    viewBox: "0 0 42.002 42.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Grupo_141",
    "data-name": "Grupo 141",
    transform: "translate(-12.499 -12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Caminho_166",
    d: "M76.211 73.246c-.511-.263-3.056-1.509-3.53-1.678s-.82-.263-1.162.263-1.331 1.678-1.641 2.03-.6.389-1.116.131c-3.038-1.519-5.03-2.709-7.032-6.145-.53-.914.53-.848 1.519-2.822a.954.954 0 0 0-.047-.9c-.131-.263-1.162-2.8-1.594-3.839-.417-1.008-.849-.867-1.163-.886s-.642-.019-.989-.019a1.911 1.911 0 0 0-1.378.642 5.813 5.813 0 0 0-1.808 4.307 10.137 10.137 0 0 0 2.1 5.349c.263.347 3.642 5.56 8.832 7.8 3.281 1.416 4.566 1.537 6.206 1.294 1-.15 3.057-1.247 3.483-2.461a4.393 4.393 0 0 0 .3-2.461c-.126-.23-.474-.361-.985-.609z",
    className: "prefix__cls-1",
    "data-name": "Caminho 166",
    transform: "translate(-33.266 -35.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Caminho_167",
    d: "M52.87 25.363A20.973 20.973 0 0 0 33.5 12.5h-.094a21.01 21.01 0 0 0-18.657 30.47v7.13a2.156 2.156 0 0 0 2.156 2.156h7.13a21.069 21.069 0 0 0 9.371 2.25h.1a20.926 20.926 0 0 0 14.79-6.071 21.077 21.077 0 0 0 4.574-23.072zM45.786 45.9A17.346 17.346 0 0 1 33.5 50.939h-.08a17.5 17.5 0 0 1-8.114-2.039l-.394-.211h-6.6v-6.6L18.1 41.7a17.484 17.484 0 0 1 3-20.481 17.307 17.307 0 0 1 12.319-5.152h.08A17.445 17.445 0 0 1 45.786 45.9z",
    className: "prefix__cls-1",
    "data-name": "Caminho 167"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.4bdddd07.svg";
export { ForwardRef as ReactComponent };